module.exports = __webpack_public_path__ + "static/media/quote-metro-edge.b2168e61.png";